//#region types
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

/**
 * @deprecated This service is deprecated. Use useSalaryDeviationsService hook instead.
 *
 * @see useSalaryDeviationsService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const SalaryDeviationsService = {
  getSalaryDeviationTypeText: (type: number, customName?: string) => {
    if (
      type === ApiModels.SalaryDeviationType.CustomDeviationCompensation ||
      type === ApiModels.SalaryDeviationType.CustomTimeDeviation
    ) {
      return `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Other)}: ${customName}`;
    }
    return LocalizationHelperInstance.getFormattedMessage(`SalaryDeviation.Type_${type}`);
  },
};

export default SalaryDeviationsService;
